import { clinicasApi } from '../../../api';
import { login, logout, checking } from './authSlice';
import { successNotification, dangerNotification } from '../ui';
import { clearNotifications } from '../ui/uiSlice';
import { clearService } from '../service/serviceSlice';
import { encrypt } from '../../../helpers/encryptionHelper';

export const startLogin = (membresia, password) => {
    return async(dispatch) => {

        dispatch(checking());

        try {

            const resp = await clinicasApi.post('/session', {
                login: membresia,
                password: encrypt(password)
            });

            if (resp.status) {

                localStorage.setItem('token', resp.data.accessToken);

                dispatch(login(resp.data));
                dispatch(clearNotifications());
                dispatch(successNotification('Usuario autenticado'));

            } else {

                dispatch(logout(resp));
                dispatch(clearService());
                dispatch(dangerNotification(resp.msg));

            }

        } catch (error) {


            if (typeof error.response !== 'undefined' && typeof error.response.data !== 'undefined' && typeof error.response.data.title !== 'undefined') {

                if(error.response.data.title.toString().includes('La contraseña ingresada es incorrecta')){

                    dispatch(logout({ msg: 'Credenciales incorrectas' }));
                    dispatch(clearService());
                    dispatch(dangerNotification('Credenciales incorrectas'));

                }else{

                    dispatch(logout({ msg: 'Error al procesar la petición, intenta nuevamente.' }));
                    dispatch(clearService());
                    dispatch(dangerNotification('Error al procesar la petición, intenta nuevamente.'));

                }


            } else {

                dispatch(logout({ msg: 'Error al procesar la petición, intenta nuevamente.' }));
                dispatch(clearService());
                dispatch(dangerNotification('Error al procesar la petición, intenta nuevamente.'));

            }

        }

    }
}

export const startAutoLogin = () => {
    return async(dispatch) => {

        const token = localStorage.getItem('token');
        if (!token) return dispatch(logout());

        try {

            const resp = await clinicasApi.post('/autoLogin');

            if (resp.status) {

                localStorage.setItem('token', resp.data.accessToken);
                dispatch(login(resp.data));

            } else {

                localStorage.removeItem('token');
                dispatch(logout());

            }

        } catch (error) {

            localStorage.removeItem('token');
            dispatch(logout());

        }

    }
}

export const startLogout = () => {
    return async(dispatch) => {

        localStorage.removeItem('token');
        dispatch(logout());
        dispatch(clearService());
        dispatch(clearNotifications());
        dispatch(successNotification('Sesión terminada'));

    }
}